// ACH has ONE source of truth: the Cleanroom Classification table (Mechanical Systems ▸ classifications, db/43).
// A room template that names a classification gets that classification's target; a template's own DefaultACH is only
// the fallback for a template with no classification (an office, a corridor). Before this, a template's separate
// DefaultACH (ISO 8 = 15) disagreed with the classification's target (ISO 8 = 30), so rooms of the same class
// ended up with different air changes (feedback #24).

const isAcPerHr = (c) => c && (c.TargetACHUnit == null || c.TargetACHUnit === "AC/HR") && Number.isFinite(Number(c.TargetACH)) && c.TargetACH !== null && c.TargetACH !== "";

/** The classification's air-change target for a room, or null (none chosen, or a non-AC/HR unit such as FPM). */
export function classificationTargetAch(classificationId, classifications = []) {
  if (classificationId == null) return null;
  const c = classifications.find(x => x.ClassificationID === classificationId);
  return isAcPerHr(c) ? Number(c.TargetACH) : null;
}

/** ACH a new room should start with for this template: classification target, else the template's own default, else null. */
export function templateAch(template, classifications = []) {
  if (!template) return null;
  const fromClass = classificationTargetAch(template.ClassificationID, classifications);
  if (fromClass != null) return fromClass;
  return template.DefaultACH != null && template.DefaultACH !== "" ? Number(template.DefaultACH) : null;
}

/**
 * A room whose ACH differs from its classification's target -> { target, classification } else null. A different value
 * is allowed (an estimator may fine-tune) — it is shown, never silently changed.
 */
export function achMismatch(room, classifications = []) {
  const target = classificationTargetAch(room?.ClassificationID, classifications);
  if (target == null) return null;
  const ach = room.ACH === null || room.ACH === undefined || room.ACH === "" ? null : Number(room.ACH);
  if (ach != null && Math.abs(ach - target) < 1e-9) return null;
  return { target, current: ach };
}
